// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AppointmentCard-module__card___rmOzz {
  width: 100%;
  display: block;
  text-align: left;
  appearance: none;
  background: var(--card-bg);
  border: 1.5px solid var(--card-border);
  border-left: 4px solid var(--card-left);
  border-radius: 8px;
  padding: 12px 14px;
  cursor: pointer;
  transition: border-color 0.15s, background-color 0.15s, box-shadow 0.15s;
  font: inherit;
}

.AppointmentCard-module__card___rmOzz:not(.AppointmentCard-module__selected___JCjcb):hover {
  border-color: #a1a1aa;
}

.AppointmentCard-module__card___rmOzz:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
}

.AppointmentCard-module__header___D0euc {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 6px;
}

.AppointmentCard-module__patientName___SwTal {
  font-size: 13px;
  font-weight: 600;
  color: #18181b;
}

.AppointmentCard-module__visitType___UpdBE {
  font-size: 11px;
  color: #52525b;
  margin-top: 1px;
}

.AppointmentCard-module__dateBlock___r_OTS {
  text-align: right;
}

.AppointmentCard-module__dateLabel___yKl7B {
  font-size: 11px;
  font-weight: 600;
  font-family: "IBM Plex Mono", monospace;
}

.AppointmentCard-module__dateSoon___kHK16 {
  color: #18181b;
}

.AppointmentCard-module__dateNormal___DfLGl {
  color: #71717a;
}

.AppointmentCard-module__timeLabel___w1pES {
  font-size: 10px;
  color: #a1a1aa;
  font-family: "IBM Plex Mono", monospace;
}

.AppointmentCard-module__dimensions___qGFcJ {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
}

.AppointmentCard-module__dimension___vhPZ_ {
  display: flex;
  align-items: center;
  gap: 3px;
  background: var(--dim-bg);
  border: 1px solid var(--dim-border);
  border-radius: 4px;
  padding: 2px 6px;
}

.AppointmentCard-module__dimensionLabel___ef1yS {
  font-size: 10px;
  font-weight: 500;
  color: #52525b;
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/AppointmentCard/AppointmentCard.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,0BAAA;EACA,sCAAA;EACA,uCAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,wEAAA;EACA,aAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,0BAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,kBAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;EACA,eAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,uCAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;EACA,uCAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;EACA,mCAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AACF","sourcesContent":[".card {\n  width: 100%;\n  display: block;\n  text-align: left;\n  appearance: none;\n  background: var(--card-bg);\n  border: 1.5px solid var(--card-border);\n  border-left: 4px solid var(--card-left);\n  border-radius: 8px;\n  padding: 12px 14px;\n  cursor: pointer;\n  transition: border-color 0.15s, background-color 0.15s, box-shadow 0.15s;\n  font: inherit;\n}\n\n.card:not(.selected):hover {\n  border-color: #a1a1aa;\n}\n\n.card:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 6px;\n}\n\n.patientName {\n  font-size: 13px;\n  font-weight: 600;\n  color: #18181b;\n}\n\n.visitType {\n  font-size: 11px;\n  color: #52525b;\n  margin-top: 1px;\n}\n\n.dateBlock {\n  text-align: right;\n}\n\n.dateLabel {\n  font-size: 11px;\n  font-weight: 600;\n  font-family: 'IBM Plex Mono', monospace;\n}\n\n.dateSoon {\n  color: #18181b;\n}\n\n.dateNormal {\n  color: #71717a;\n}\n\n.timeLabel {\n  font-size: 10px;\n  color: #a1a1aa;\n  font-family: 'IBM Plex Mono', monospace;\n}\n\n.dimensions {\n  display: flex;\n  gap: 4px;\n  flex-wrap: wrap;\n}\n\n.dimension {\n  display: flex;\n  align-items: center;\n  gap: 3px;\n  background: var(--dim-bg);\n  border: 1px solid var(--dim-border);\n  border-radius: 4px;\n  padding: 2px 6px;\n}\n\n.dimensionLabel {\n  font-size: 10px;\n  font-weight: 500;\n  color: #52525b;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `AppointmentCard-module__card___rmOzz`,
	"selected": `AppointmentCard-module__selected___JCjcb`,
	"header": `AppointmentCard-module__header___D0euc`,
	"patientName": `AppointmentCard-module__patientName___SwTal`,
	"visitType": `AppointmentCard-module__visitType___UpdBE`,
	"dateBlock": `AppointmentCard-module__dateBlock___r_OTS`,
	"dateLabel": `AppointmentCard-module__dateLabel___yKl7B`,
	"dateSoon": `AppointmentCard-module__dateSoon___kHK16`,
	"dateNormal": `AppointmentCard-module__dateNormal___DfLGl`,
	"timeLabel": `AppointmentCard-module__timeLabel___w1pES`,
	"dimensions": `AppointmentCard-module__dimensions___qGFcJ`,
	"dimension": `AppointmentCard-module__dimension___vhPZ_`,
	"dimensionLabel": `AppointmentCard-module__dimensionLabel___ef1yS`
};
module.exports = ___CSS_LOADER_EXPORT___;
